"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function recursivePartialOverride(x, y) {
    if (y === undefined || y === null)
        return x;
    const objProto = Object.getPrototypeOf({});
    if (Object.getPrototypeOf(y) != objProto)
        return y;
    let v = Object.assign({}, x);
    let yKeys = Object.keys(y);
    const allKeys = uniq(Object.keys(v).concat(yKeys));
    for (const key of allKeys) {
        if (yKeys.indexOf(key) >= 0) {
            const itemKeyVal = y[key];
            if (null != itemKeyVal && typeof itemKeyVal === "object") {
                const baseKeyVal = v[key];
                v[key] = recursivePartialOverride(baseKeyVal, itemKeyVal);
            }
            else {
                v[key] = itemKeyVal;
            }
        }
    }
    return v;
}
exports.recursivePartialOverride = recursivePartialOverride;
function uniq(ts) {
    const out = [];
    for (const v of ts) {
        if (out.indexOf(v) < 0) {
            out.push(v);
        }
    }
    return out;
}
exports.uniq = uniq;
